<template>
  <div
    class="item"
    @click="$router.push({
      name: routeTo,
      params: {
        id: demande.organisation && demande.organisation.id ? demande.organisation.id : demande.id
      }
    })"
  >
    <div class="row">
      <div class="col-10 content">
        <div class="row top">
          <div class="icon-col col-2">
            <img
              v-if="icon.length"
              :src="getSvgUrl()"
              alt="Icon request button"
            >
          </div>
          <div class="col-10">
            {{ demande.status === 1 ? 'Validation' : 'Vérification' }} {{ type }}
          </div>
        </div>
        <div class="bottom">
          <div class="email">
            {{ demande.username || demande.codename }}
          </div>
          <div class="date">
            {{ demande.date_joined ?
              new Date(demande.date_joined).toLocaleString('fr-FR', {year: "numeric", month: "numeric", day: "numeric"}) :
              new Date(demande.creation_date).toLocaleString('fr-FR', {year: "numeric", month: "numeric", day: "numeric"}) }}
          </div>
        </div>
      </div>
      <div class="arrow-col col-2">
        <b-icon-chevron-right
          class="h2"
          scale="1.25"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountDemande',

  props: {
    type: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    routeTo: {
      type: String,
      default: 'UserDetail'
    },
    demande: {
      type: Object,
      default: () => { return {}; }
    }
  },

  methods: {
    getSvgUrl() {
      const images = require.context('@/assets/icons/', false, /\.svg$/);
      return images(`./${this.icon}.svg`);
    }
  }
};
</script>

<style lang="less" scoped>
.item {
  cursor: pointer;
  height: 4.5em;
  margin-bottom: 0.5em;
  color: @blue;
  border-radius: 3px;
  border: 1px solid #A9B2B9;
  box-shadow: 0 0 1px 1px #A9B2B9;
  .row {
    height: 100%;
    margin: 0;
    .content {
      padding: 0.25rem 0;
      .top {
        height: 65%;
        .icon-col {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 1.5em;
            height: 1.5em;
          }
        }
        .col-10 {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          margin-left: -0.5em;
          div:first-child {
            font-size: 1em;
            font-weight: 500;
          }
          div {
            font-size: 0.9em;
          }
        }
      }
      .bottom {
        height: 35%;
        margin: 0 1.5rem;
        font-size: 0.9em;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .email {
          color: rgb(77, 77, 77);
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .date {
          color: rgb(160, 159, 159);
          font-weight: 600;
        }
      }
    }
    .arrow-col {
      height: 100%;
      display: flex;
      align-items: center;
      .b-icon {
        margin: 0;
      }
    }
  }
}
.item:hover {
  background-color: whitesmoke;
}
.item.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
